function targetScrollReloadingPage() {
 window.addEventListener('DOMContentLoaded', function () {
  var target = window.location.hash;
  if (target !== '') {
   $('html, body').animate({
    scrollTop: $(`${target}`).offset().top
   }, 1500);
  }
 })
}

targetScrollReloadingPage()

function scrollToForm() {
 let linsService = document.querySelectorAll('a[data-service-slug]');
 if (linsService.length > 0) {
  let contactSection = document.querySelector('#contact-form-box');
  let select = document.querySelector('.wpcf7-form').querySelector('select');
  let hrefAttr;
  for (let i = 0; i < linsService.length; i++) {
   linsService[i].addEventListener('click', function (e) {
    e.preventDefault();
    hrefAttr = linsService[i].getAttribute('data-service-slug');

    window.scrollBy({
     top: contactSection.getBoundingClientRect().top,
     behavior: "smooth"
    })

    select.value = hrefAttr;
   })
  }
 }
}
scrollToForm()